import {PageHeader} from '@primer/react'
import type {ReactNode} from 'react'

import styles from './PropertyPageHeader.module.css'

interface Props {
  title: ReactNode
  subtitle?: ReactNode
  actions?: ReactNode
}
export function PropertyPageHeader({title, subtitle, actions}: Props) {
  return (
    <>
      <PageHeader>
        <PageHeader.TitleArea className={styles.PageHeader_TitleArea}>
          {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
          <PageHeader.Title as="h2" className="h1-override-shared-component">
            {title}
          </PageHeader.Title>
        </PageHeader.TitleArea>
        <PageHeader.Actions>
          {actions ? <div className={styles.actionsContainer}>{actions}</div> : null}
        </PageHeader.Actions>
      </PageHeader>
      {subtitle ? <p className={styles.subtitleText}>{subtitle}</p> : null}
    </>
  )
}
